import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2022-01-22'
        tag='Vinted'
        title='A Poshmark Reseller Guide: Where To Get Real Vintage Pieces'
      >
        <p>
          Poshmark is not a vintage platform. As such, it is not easy to sell vintage. So, sellers must be very
          strategic about price, inventory, and sourcing items that you can resell on this online store.
        </p>
        <p>
          Sometimes, a vintage item will not get appreciation from the platform users; nevertheless, it would still be
          wise to keep these items on their list for customer visibility. Some vintage goods are trendy enough and have
          been circulating social media that still appeal to the modern styles of Poshmark buyers. Young shoppers, Gen
          Z, in particular, are keen on getting their hands on these rare items for their collection.
        </p>
        <p>
          Modern brands like Forever21, H&M, and Urban Outfitters are collaborating with vintage fashion labels to
          compete with this hot aspect of the vintage market. As for vintage jewelry, designers Chanel and Christian
          Dior and Vintage Native American jewelry are some brands that sell well on Poshmark.
        </p>

        <h3>What is considered vintage?</h3>
        <p>
          To be qualified as a true vintage, an item has to be anything between 20 to 99 years old. These pieces can be
          stylish, unique, and classy, such as designer secondhand clothes and handbags, official band merchandise like
          t-shirts, and antique jewelry or accessories. However, take note that selling vintage garments or a specific
          category has a niche audience. This is why you need to consider which platforms or resale sites to sell on.
        </p>
        <p>
          When selling on Poshmark, you have to ensure that it is classic or antiqued if you identify something as
          vintage. You must describe what you are selling accurately in your description box to prevent Poshmark from
          overturning a sale or allowing a return. Be careful with flaws because what might not be important to you is
          definitely important with buyers.
        </p>
        <p>
          Take note that customers do not go to Poshmark to look for vintage items right away. What buyers are looking
          for are trendy items, and if it happens to be retro and priced right, they will purchase it. They will feel
          they made a good deal.
        </p>

        <h3>Where to source vintage items?</h3>
        <p>There are so many sources of vintage items that one can sell on Poshmark.</p>

        <strong>Your Closet</strong>
        <p>
          Start here. Make an inventory of your things: what you need and want to let go of. You can price them
          accordingly because you know how much you will tag them for their sale price. Consider the place and the time
          you bought them as well. There are instances when the era it comes from matters for you to increase the item's
          price. You may check out several platforms like Asos Marketplace and other vendors to understand what quickly
          sells and how to price similar items.
        </p>

        <strong>Your Family's Closets</strong>
        <p>
          Ask family members for things they are no longer using. Engage them in your plan to de-clutter the closets and
          make money out of items that they no longer needed. Who knows, their taste in fashion has changed, and so you
          can get your hands on their items, especially from parents, and resell these vintage pieces.{' '}
        </p>

        <strong>Garage Sales</strong>
        <p>
          We often learn of garage sales through announcements within the neighborhood, Facebook market groups, or on
          the internet, in general. Garage sales are the best sources of pre-loved items. You can inspect the items in
          natural light so it will be easier to see flaws and stains, especially in clothes. Many items are priced
          relatively low in garage sales because people want these items to "move," and so you should take advantage of
          this.{' '}
        </p>

        <strong>Estate Sales</strong>
        <p>
          When visiting these types of sales, you will find so many items because technically, you are shopping the
          entire house from the living room, dining room, kitchen, and up to the closets. It is very likely you can find
          treasures like rare collections (think of fine china and antique furniture) and vintage clothing. However, the
          downside is that the prices are often high compared to garage sales.
        </p>
        <p>
          To search for these, you can look them up in your neighborhood or city—be it New York, Miami, Brooklyn, or Los
          Angeles—for these places usually have well-known estate sales you can trust that sells a wide selection of
          items.
        </p>

        <strong>Thrift Stores</strong>
        <p>
          When shopping in thrift stores, you have to be patient as there are many pieces, especially fast fashion, to
          go through. From garments to accessories to shoes, rummaging through them to find rare and good items may take
          a while.
        </p>
        <p>
          The advantage here is buying them in bulk and getting them all for a specific flat rate. You can also
          negotiate for the price. Be sure to bring extra cash with you as you will never know how much goods you will
          get.
        </p>

        <strong>Rummage Sales</strong>
        <p>
          People donate their items throughout the year to churches and hospitals, which have annual rummage sales. The
          prices are usually reasonable, and digging through the heaps of clothing trying to look for vintage items is
          worth it.
        </p>
        <p>
          ThredUp, for instance, is an online consignment store that has a Donation Program. The marketplace donates a
          reseller's unsold clothes (after an agreement, of course) to a particular charity of their choice.
        </p>

        <strong>Clothing Consignment Stores</strong>
        <p>
          There are a few boutique consignment stores within your area. Make sure to be updated when these stores start
          having their 75% or 90% off sales. There are some items that you can get for as low as 2%.{' '}
        </p>

        <strong>Outlets</strong>
        <p>
          You have to be extremely careful in looking and buying in these outlets. Although they will sell items at a
          50% discount, do your computations as this might not sell in Poshmark. Try to source higher-priced items at a
          deeper discount.
        </p>

        <h3>Is selling vintage worth it?</h3>
        <p>
          It is not enough that you source cheap items from these various destinations. Take note that cheaper pieces
          don't always mean you made a good deal.
        </p>
        <p>
          Selling these on Poshmark has additional fees you need to consider. Remember that you have to pay $7.45 for
          shipping, so you have to take note of this when pricing your goods. Sometimes, you need to "pad" your prices
          to make a profit.
        </p>
        <p>
          Keep in mind that some buyers will make an offer that may be lower than your original price. This is why you
          need to do also your research: check other platforms like Depop and Mercari for their prices of similar items
          you are selling.
        </p>

        <p>
          Overall, if you can get your hand on a retro piece or a really rare item, then people will most likely be
          willing to pay a high price for them. After all, these can be part of their collections, especially the
          younger ones, that they pose on Instagram or other social media accounts to show off.
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
